import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import {
  Box,
  Button,
  Heading,
  HStack,
  Input,
  NumberInput,
  NumberInputField,
  Text,
  Textarea,
  VStack,
} from '@chakra-ui/react';

import { CREATE_SPIRIT_POINT_TEMPLATE } from '../../../GraphQL/Mutations';

export const AddTemplateForm = ({ eventId, onCreate, onError }) => {
  const [title, setTitle] = useState('');
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');

  const [createTemplate, { loading }] = useMutation(CREATE_SPIRIT_POINT_TEMPLATE, {
    onCompleted: (data) => {
      onCreate(data.createSpiritPointTemplate.template);
      setTitle('');
      setAmount('');
      setDescription('');
    },
    onError: (err) => {
      onError(err.graphQLErrors?.[0]?.message ?? err.message);
    },
  });

  const handleSubmit = () => {
    if (!title.trim()) {
      onError('Title is required');
      return;
    }
    if (amount === '' || amount === null) {
      onError('Point value is required');
      return;
    }

    createTemplate({
      variables: {
        input: {
          eventId,
          title: title.trim(),
          amount: parseInt(amount, 10),
          description: description.trim() || title.trim(),
        },
      },
    });
  };

  const isValid = title.trim() && amount !== '' && amount !== null;

  return (
    <Box>
      <Heading size="md" mb={4}>Add New Template:</Heading>

      <VStack align="stretch" spacing={4} maxW="500px">
        <HStack>
          <Text minW="100px">Title:</Text>
          <Input
            bg="white"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </HStack>

        <HStack>
          <Text minW="100px">Points:</Text>
          <NumberInput value={amount} onChange={(val) => setAmount(val)} maxW="150px">
            <NumberInputField bg="white" placeholder="e.g., 5 or -10" />
          </NumberInput>
        </HStack>

        <HStack alignItems="flex-start">
          <Text minW="100px" pt={2}>Description:</Text>
          <Textarea
            bg="white"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="(optional)"
            rows={2}
          />
        </HStack>

        <Box textAlign="center">
          <Button
            colorScheme="gray"
            onClick={handleSubmit}
            isLoading={loading}
            isDisabled={!isValid}
          >
            ADD
          </Button>
        </Box>
      </VStack>
    </Box>
  );
};

AddTemplateForm.propTypes = {
  eventId: PropTypes.number.isRequired,
  onCreate: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};
